module.exports = __webpack_public_path__ + "statics/img/gongnengbg.c9836abb.png";